module.exports = __webpack_public_path__ + "static/media/comment-alt-dots.2b04ce77.svg";